import styled from "styled-components";

export const Container = styled.div`
  margin-bottom: 20px;
  width: 100%;
`;

export const Card = styled.div`
  background: linear-gradient(135deg, #e8f4fd 0%, #d4ecfc 100%);
  border-left: 4px solid #007ded;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 125, 237, 0.15);
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  user-select: none;
`;

export const Title = styled.h3`
  color: #053779;
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;

  svg {
    color: #007ded;
  }
`;

export const ToggleButton = styled.button`
  background: transparent;
  border: none;
  color: #007ded;
  cursor: pointer;
  padding: 4px 8px;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.8;
  }
`;

export const Content = styled.div<{ $isExpanded: boolean }>`
  max-height: ${({ $isExpanded }) => ($isExpanded ? "500px" : "0")};
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;
`;

export const ObservationItem = styled.div`
  background: white;
  border-radius: 6px;
  padding: 12px;
  margin-top: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
`;

export const ObservationDate = styled.span`
  font-size: 12px;
  color: #919296;
  font-weight: 500;
  display: block;
  margin-bottom: 6px;
`;

export const ObservationText = styled.p`
  color: #343536;
  font-size: 14px;
  line-height: 1.5;
  margin: 0;
  white-space: pre-wrap;
`;

export const NoObservations = styled.div`
  color: #919296;
  font-size: 14px;
  text-align: center;
  padding: 12px;
  margin-top: 12px;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
`;

export const Badge = styled.span`
  background-color: #007ded;
  color: white;
  border-radius: 12px;
  padding: 2px 8px;
  font-size: 12px;
  font-weight: 600;
  margin-left: 8px;
`;














